
export default {
  name: 'Expander',

  props: {
    toggler: Boolean,
    id: {
      type: String,
      required: true
    },
    name: { type: String, default: '' }
  },

  computed: {
    toggle: {
      get() {
        return this.toggler
      },
      set(bool) {
        this.$emit('update:toggler', bool)
      }
    }
  },

  methods: {
    expanderToggler() {
      this.toggle = !this.toggle
    }
  }
}
